import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCurrentDate } from '../services/billService';

const PaymentSummary = ({ bills, costs }) => {
  const { t, i18n } = useTranslation('home');
  const numLocale = i18n.language === 'en' ? 'en-GB' : 'tr-TR';
  const today = getCurrentDate();

  const todaysIncome = bills
    .filter(bill => bill.date === today)
    .reduce((acc, bill) => {
      const type = bill.paymentType || 'Diğer';
      acc[type] = (acc[type] || 0) + (Number(bill.totalPrice || bill.price) || 0);
      return acc;
    }, {});

  const todaysCosts = costs
    .filter(cost => cost.date === today)
    .reduce((acc, cost) => {
      const type = cost.paymentType || 'Diğer';
      acc[type] = (acc[type] || 0) + (Number(cost.price) || 0);
      return acc;
    }, {});

  const incomeStyles = {
    'Nakit':      'bg-green-100 text-green-800 border-green-200',
    'Kredi Kartı':'bg-blue-100 text-blue-800 border-blue-200',
    'Havale':     'bg-purple-100 text-purple-800 border-purple-200',
  };
  const expenseStyles = {
    'Nakit':      'bg-yellow-100 text-yellow-800 border-yellow-200',
    'Kredi Kartı':'bg-orange-100 text-orange-800 border-orange-200',
    'Havale':     'bg-rose-100 text-rose-800 border-rose-200',
  };

  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6">
      <div className="flex-1">
        <h2 className="text-lg font-semibold text-gray-700 text-center mb-4">
          {t('paymentSummary.incomeTitle')}
        </h2>
        <div className="grid grid-cols-3 gap-4">
          {['Nakit', 'Kredi Kartı', 'Havale'].map((type) => (
            <div key={type} className={`p-4 rounded-lg border shadow-sm ${incomeStyles[type]}`}>
              <div className="text-sm font-medium">
                {type === 'Nakit' ? t('paymentSummary.cash') : type === 'Kredi Kartı' ? t('paymentSummary.creditCard') : t('paymentSummary.transfer')}
              </div>
              <div className="text-lg font-bold mt-1">
                {(todaysIncome[type] || 0).toLocaleString(numLocale)} TL
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="md:w-px md:h-auto md:bg-gray-200"></div>

      <div className="flex-1">
        <h2 className="text-lg font-semibold text-gray-700 text-center mb-4">
          {t('paymentSummary.expenseTitle')}
        </h2>
        <div className="grid grid-cols-3 gap-4">
          {['Nakit', 'Kredi Kartı', 'Havale'].map((type) => (
            <div key={type} className={`p-4 rounded-lg border shadow-sm ${expenseStyles[type]}`}>
              <div className="text-sm font-medium">
                {type === 'Nakit' ? t('paymentSummary.cash') : type === 'Kredi Kartı' ? t('paymentSummary.creditCard') : t('paymentSummary.transfer')}
              </div>
              <div className="text-lg font-bold mt-1">
                {(todaysCosts[type] || 0).toLocaleString(numLocale)} TL
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PaymentSummary;
